var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#6E6259",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1390 2734 c-14 -2 -59 -9 -100 -15 -41 -6 -121 -26 -178 -45 -432 -141 -752 -512 -833 -964 -17 -96 -17 -324 0 -420 81 -452 401 -823 833 -964 143 -47 231 -60 388 -60 157 0 245 13 388 60 432 141 752 512 833 964 17 96 17 324 0 420 -90 507 -481 906 -985 1006 -72 14 -300 26 -346 18z m383 -168 c111 -28 255 -93 347 -156 82 -56 198 -167 261 -249 69 -92 154 -267 186 -386 24 -90 27 -117 27 -275 0 -158 -3 -185 -27 -275 -32 -119 -117 -294 -186 -386 -63 -82 -179 -193 -261 -249 -91 -62 -235 -127 -347 -157 -88 -24 -115 -27 -273 -27 -158 0 -185 3 -275 27 -119 32 -294 117 -386 186 -82 63 -193 179 -249 261 -62 91 -127 235 -157 347 -24 88 -27 115 -27 273 0 158 3 185 27 273 82 305 284 560 557 701 182 95 327 127 540 122 114 -3 166 -9 243 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455 2201 c-45 -20 -70 -60 -70 -112 0 -42 5 -53 33 -81 28 -28 39 -33 82 -33 43 0 54 5 82 33 28 28 33 39 33 82 0 42 -5 54 -31 81 -33 33 -92 46 -129 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455 1795 l-25 -24 0 -471 0 -471 25 -24 c31 -32 59 -32 90 0 l25 24 0 471 0 471 -25 24 c-13 14 -33 25 -45 25 -11 0 -32 -11 -45 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLegal);
export default __webpack_public_path__ + "static/media/info-legal.f3c58f90.svg";
export { ForwardRef as ReactComponent };